function live(backendAxiosInstance) {
  async function getChannels(assetToken) {
    return backendAxiosInstance.get("/contents/v2/live/channels", {
      params: {
        assetToken
      }
    });
  }
  async function getSchedules({
    startTime,
    endTime,
    channelId: channelIds,
    assetToken,
    pageSize,
    ...restParams
  }) {
    return backendAxiosInstance.get("/contents/v2/live/schedules", {
      params: {
        startTime: startTime.toISOString(),
        endTime: endTime?.toISOString(),
        channelId: channelIds.join(","),
        assetToken,
        pageSize,
        ...restParams
      },
      includeLanguage: true
    });
  }
  async function getSchedulesByEventType(channel, {
    assetToken,
    eventType,
    pageSize
  }) {
    return backendAxiosInstance.get(`/contents/v2/live/schedules/channel/${channel}`, {
      params: {
        eventType,
        pageSize,
        assetToken
      },
      includeLanguage: true
    });
  }
  return {
    getChannels,
    getSchedules,
    getSchedulesByEventType
  };
}

export { live as default };
//# sourceMappingURL=live.js.map
